// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1ZR5o","resendInfoText":"OnGoingPaymentBox_resendInfoText__MgFRg"};